import { FC } from 'react';

import { SubmissionListResponseOutputItemsItem } from '@/api/generated';
import { SubmissionsTableBody } from '@/components/blocks/submissions/submissions-table-body';
import { SubmissionsTableHeader } from '@/components/blocks/submissions/submissions-table-header';
import { Table } from '@/components/ui/table';
import { cn } from '@/lib/utils';

interface SubmissionsTableProps {
  className?: string;
  submissions: Array<SubmissionListResponseOutputItemsItem>;
  customerId: string;
}

export const SubmissionsTable: FC<SubmissionsTableProps> = ({
  className,
  ...submissionsTableProps
}: SubmissionsTableProps) => (
  <Table
    className={cn(
      '[&_td:first-child]:pl-4 [&_td:last-child]:pr-4 [&_th:first-child]:pl-4 [&_th:last-child]:pr-4',
      className
    )}>
    <SubmissionsTableHeader />
    <SubmissionsTableBody {...submissionsTableProps} />
  </Table>
);
